export enum FireblocksWalletModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
